import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import './config/i18n';
import setupInterceptors from './api/setupInterceptors';
import './scss/app.scss';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { getLocalStorage } from 'utils/sessionStorage';
import { KEY_THEME_LOCALSTORAGE } from 'consts/app';
import { WagmiProvider } from 'wagmi';
import { http, createConfig } from 'wagmi';
import { base, mainnet, bscTestnet, bsc, polygon, sepolia, polygonAmoy } from 'wagmi/chains';
import { walletConnect } from 'wagmi/connectors';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MessageProvider } from 'components/Hoc/MessageProvider';

export const config = createConfig({
  chains: [mainnet, base, bsc, bscTestnet, polygon, sepolia, polygonAmoy],
  connectors: [
    walletConnect({
      projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || '',
      qrModalOptions: {
        themeVariables: {
          '--wcm-z-index': '2000',
        },
      },
    }),
  ],
  transports: {
    [mainnet.id]: http(),
    [base.id]: http(),
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
    [polygon.id]: http(),
    [sepolia.id]: http(),
    [polygonAmoy.id]: http(),
  },
});

const queryClient = new QueryClient();

const themes = {
  dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/light-theme.css`,
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeSwitcherProvider
        defaultTheme={getLocalStorage(KEY_THEME_LOCALSTORAGE) === 'light' ? 'light' : 'dark'}
        insertionPoint={document.getElementById('inject-styles-here')}
        themeMap={themes}
      >
        <Suspense>
          <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
              <MessageProvider>
                <App />
              </MessageProvider>
            </QueryClientProvider>
          </WagmiProvider>
        </Suspense>
      </ThemeSwitcherProvider>
    </BrowserRouter>
  </Provider>,
);

setupInterceptors(store);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
